import type { Capitolo } from '../tipi.ts'

const capitolo: Capitolo = {
  id: 'area-riservata',
  titolo: 'Area riservata e chat riservata',
  gruppo: 'Il lavoro con le persone',
  permesso: ['riservato.leggi', 'riservato.scrivi'],
  aCheServe: 'Le informazioni più delicate (violenza, tratta, sfruttamento, rischio per l’incolumità) stanno '
    + 'nell’area riservata della scheda. Si apre solo scrivendo il motivo, e ogni apertura resta registrata.',
  parti: [
    {
      titolo: 'Aprire l’area riservata',
      passi: [
        'Nella scheda apri la linguetta «Area riservata».',
        'Scrivi il «Motivo dell’apertura», per esempio «preparazione del colloquio del 15 novembre».',
        'Premi «Apri l’area riservata». Compaiono le note, con i temi, l’autore e la data.',
      ],
      immagine: {
        file: 'area-riservata.webp', larghezza: 1200, altezza: 800,
        descrizione: 'La linguetta Area riservata con il campo Motivo dell’apertura.',
      },
      nota: 'Project Manager e coordinatori la leggono e la scrivono; l’operatore interno sulle schede che ha '
        + 'creato; la Direzione la legge. Chi non ha titolo non sa nemmeno se c’è qualcosa.',
    },
    {
      titolo: 'Scrivere una nota riservata',
      permesso: 'riservato.scrivi',
      passi: [
        'Aperta l’area, nel riquadro «Nuova nota riservata» scegli uno o più «Temi».',
        'Scrivi il «Testo della nota» e premi «Salva la nota».',
      ],
      nota: 'La scheda riceve il lucchetto «Area riservata» negli elenchi. I temi servono a ritrovare la nota, non '
        + 'decidono chi la legge.',
    },
    {
      titolo: 'La chat riservata della scheda',
      testo: [
        'È l’unico posto del messenger dove si parla della persona, anche con lei. Nel messenger lo spazio si '
          + 'chiama solo «Scheda riservata n. …», senza nomi.',
      ],
      passi: [
        'Nella linguetta «Area riservata», riquadro «Chat riservata», premi «Crea la chat riservata». Il comando '
          + 'c’è solo se la scheda ha almeno una nota riservata.',
        'Nascono due sotto-chat: «Équipe», solo per il personale, e «Con la persona».',
        '«Apri nel messenger» porta direttamente alla chat.',
        'Per far entrare la persona premi «Accesso della persona»: nome utente e parola d’accesso compaiono una '
          + 'volta sola, da consegnare di persona.',
        'Quando non serve più, premi «Chiudi la chat»: si legge e basta, e si cancella dopo 90 giorni.',
      ],
      nota: 'Per tenerla più a lungo c’è «Chiedi un’estensione», con il motivo e il consenso della persona.',
    },
  ],
  avvertenze: [
    {
      quando: 'Un collega che ti sostituisce non vede l’area riservata.',
      cosaFare: 'L’apertura a un collega e l’accesso straordinario passano da un’approvazione a quattro occhi: '
        + 'chiedili alla Direzione o alla Referente privacy.',
    },
    {
      quando: 'Non trovi «Crea la chat riservata».',
      cosaFare: 'Prima scrivi almeno una nota nell’area riservata.',
    },
    {
      quando: 'Hai mostrato per sbaglio la parola d’accesso della persona.',
      cosaFare: 'Premi di nuovo «Accesso della persona»: l’accesso si rinnova e i dispositivi di prima si scollegano.',
    },
  ],
  vediAnche: ['messenger', 'scheda'],
  parole: ['riservato', 'violenza', 'tratta', 'sfruttamento', 'note', 'motivo', 'chat', 'element'],
}

export default capitolo
